import React from 'react';
import { Paper, TextField, Button, Box, InputAdornment, Typography, Tooltip, IconButton, ButtonGroup } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';

const SearchBar = ({
  inboxName,
  setInboxName,
  handleSearch,
  generateRandomInboxName,
  loading,
  currentInbox,
  handleCopyInboxName,
  handleDeleteInbox,
  emailCount,
}) => {
  return (
    <Paper elevation={0} sx={{ p: 2, borderBottom: 1, borderColor: 'divider', borderRadius: 0 }}>
      <Box component="form" onSubmit={handleSearch} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <TextField
          label="Enter or generate an inbox name"
          variant="outlined"
          size="small"
          value={inboxName}
          onChange={(e) => setInboxName(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ flexGrow: 1 }}
        />
        <ButtonGroup variant="contained" size="medium">
          <Button
            type="submit"
            disabled={loading || !inboxName}
            sx={{
              borderRightColor: 'rgba(255, 255, 255, 0.23) !important'
            }}
          >
            Get Mail
          </Button>
          <Button
            onClick={generateRandomInboxName}
            disabled={loading}
            aria-label="generate random inbox"
          >
            <AutoAwesomeIcon />
          </Button>
        </ButtonGroup>
      </Box>
      {currentInbox && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Inbox:
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
              {currentInbox}
            </Typography>
            <Tooltip title="Copy email address">
              <IconButton onClick={handleCopyInboxName} size="small">
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Typography variant="body2" color="text.secondary">
              ({emailCount} emails)
            </Typography>
          </Box>
          <Button
            color="error"
            size="small"
            startIcon={<DeleteIcon />}
            onClick={handleDeleteInbox}
            disabled={loading || emailCount === 0}
            sx={{ textTransform: 'none' }}
          >
            Clear
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default SearchBar;
